import { API_REQUEST_PREFIX } from '@shared/config/api/api-prefixes';
import {
    ApproveRequestDataRequest,
    ApproveRequestDataResponse,
    CancelRequestDataRequest,
    CancelRequestDataResponse,
    CreateRequestDataRequest,
    CreateRequestDataResponse,
    RejectRequestDataRequest,
    RejectRequestDataResponse,
} from './request-types';
import { requestBaseApi } from '@entities/request/api/base';

export const requestApi = requestBaseApi.injectEndpoints({
    endpoints: (build) => ({
        rejectRequest: build.mutation<RejectRequestDataResponse, RejectRequestDataRequest>({
            query: ({ id, comment }) => {
                return {
                    url: `${API_REQUEST_PREFIX}/${id}/reject`,
                    method: 'POST',
                    body: { comment },
                };
            },
            invalidatesTags: ['RequestsList'],
        }),
        cancelRequest: build.mutation<CancelRequestDataResponse, CancelRequestDataRequest>({
            query: (id) => {
                return {
                    url: `${API_REQUEST_PREFIX}/${id}/cancel`,
                    method: 'POST',
                };
            },
            invalidatesTags: ['RequestsList'],
        }),
        createRequest: build.mutation<CreateRequestDataResponse, CreateRequestDataRequest>({
            query: (data) => {
                return {
                    url: `${API_REQUEST_PREFIX}`,
                    method: 'POST',
                    body: data,
                };
            },
            invalidatesTags: ['RequestsList'],
        }),
        approveRequest: build.mutation<ApproveRequestDataResponse, ApproveRequestDataRequest>({
            query: (id) => {
                return {
                    url: `${API_REQUEST_PREFIX}/${id}/approve`,
                    method: 'POST',
                };
            },
            invalidatesTags: ['RequestsList'],
        }),
    }),
});

export const {
    useRejectRequestMutation,
    useApproveRequestMutation,
    useCancelRequestMutation,
    useCreateRequestMutation,
} = requestApi;
